export const Colors = {
  // Brand Color
  plum_paddl: '#5320a3',
  // Main Colors
  plum_electric: '#4d38e1',
  plum_electric_active: '#6855e5',
  plum_dark: '#441e80',
  plum_darker: '#350466',
  plum_dark_active: '#1f0145',
  charcoal: '#2d2936',
  new_grey: '#797596',
  new_grey_dark: '#5b5776',
  new_grey_light: '#aeacc0',
  new_grey_lighter: '#d9d8e3',
  grey_lighter: '#e4e3ea',
  grey_athens: '#f8f8f9',
  // legacy
  grey_magnolia: '#faf9fb',
  white: '#ffffff',
  blue_dark: '#006def',
  blue: '#1a91ff',
  blue_light: '#5eb2ff',
  blue_lighter: '#aed8ff',
  blue_lightest: '#dff0ff',
  // Secondary Colors
  sec_red_darker: '#d32859',
  sec_red_dark: '#e33b6b',
  sec_red: '#f75183',
  sec_red_light: '#ff8bae',
  sec_red_lighter: '#fdd4e0',
  sec_orange_darker: '#f05C42',
  sec_orange_dark: '#fd7152',
  sec_orange: '#ff8267',
  sec_orange_light: '#ffb4a4',
  sec_orange_lighter: '#ffe0d9',
  sec_yellow_darker: '#f3a016',
  sec_yellow_dark: '#ffc128',
  sec_yellow: '#ffcf59',
  sec_yellow_light: '#ffe29b',
  sec_yellow_lighter: '#fff3d5',
  sec_green_darker: '#01ba99',
  sec_green_dark: '#2bd09f',
  sec_green: '#44dda6',
  sec_green_light: '#8febca',
  sec_green_lighter: '#d0f6e9',
  sec_blue_darker: '#00b3da',
  sec_blue_dark: '#00ceea',
  sec_blue: '#00d8f5',
  sec_blue_light: '#66e8f9',
  sec_blue_lighter: '#bff5fd',
  sec_purple_darker: '#7b3ded',
  sec_purple_dark: '#8e57f0',
  sec_purple: '#a167ff',
  sec_purple_light: '#c7a4ff',
  sec_purple_lighter: '#e7d9ff',
  // Social Colors
  social_behance: '#0057ff',
  social_dribbble: '#ea4c80',
  social_facebook: '#3b5998',
  social_email: '#aeacc0',
  social_instagram: '#dd3073',
  social_github: '#1b1817',
  social_linkedin: '#0077b5',
  social_twitter: '#00a9f1'
};